// extracted by mini-css-extract-plugin
export default {"lista":"SobreMim_lista__RBL9C","item":"SobreMim_item__raW2L"};